import React, { useMemo } from 'react';
import styled from 'styled-components';

import Seo from '../components/Seo';
import { calculateProfile } from '../utils/profileCalculator';
import { questions } from '../data/questions';

const Page = styled.div`
  min-height: 100vh;
  padding: 2rem;
`;

const Container = styled.div`
  max-width: 980px;
  margin: 0 auto;
`;

const Card = styled.div`
  background: rgba(18, 18, 18, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius);
  padding: 1.25rem;
  margin-bottom: 1rem;
  backdrop-filter: blur(10px);
`;

const Title = styled.h1`
  margin: 0 0 0.5rem;
  color: var(--text-primary);
  font-size: 1.8rem;
`;

const Note = styled.p`
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.6;
`;

const Code = styled.pre`
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 1rem;
  overflow: auto;
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.9rem;
  line-height: 1.45;
`;

const buildAnswers = (type) =>
  questions.map((q) => ({
    questionId: q.id,
    questionText: q.text,
    optionId: 'x',
    optionText: `[lab] ${type}`,
    type,
  }));

const patterns = [
  { id: 'all-visionary', label: 'All visionary', answers: buildAnswers('visionary') },
  { id: 'all-executor', label: 'All executor', answers: buildAnswers('executor') },
  { id: 'all-analyst', label: 'All analyst', answers: buildAnswers('analyst') },
  { id: 'all-strategist', label: 'All strategist', answers: buildAnswers('strategist') },
  { id: 'all-innovator', label: 'All innovator', answers: buildAnswers('innovator') },
  { id: 'all-relationship', label: 'All relationship builder', answers: buildAnswers('relationshipBuilder') },
];

const ScoringLab = () => {
  const results = useMemo(() => {
    return patterns.map((p) => ({
      id: p.id,
      label: p.label,
      profile: calculateProfile(p.answers),
    }));
  }, []);

  return (
    <Page>
      <Seo title="Scoring lab" description="Dev scoring harness" path="/scoring-lab" imagePath="/favicon.svg" />
      <Container>
        <Card>
          <Title>Scoring lab</Title>
          <Note>
            Dev only page. This helps validate scoring weights, confidence, and archetypes with simple patterns.
          </Note>
        </Card>
        {results.map((r) => (
          <Card key={r.id}>
            <h2 style={{ margin: 0, color: 'var(--text-primary)', fontSize: '1.2rem' }}>{r.label}</h2>
            <Code>{JSON.stringify({
              primaryType: r.profile.primaryType,
              secondaryType: r.profile.secondaryType,
              confidence: r.profile.confidence,
              percentages: r.profile.percentages,
              archetypes: r.profile.archetypes?.primary ? {
                primary: r.profile.archetypes.primary,
                secondary: r.profile.archetypes.secondary,
                confidence: r.profile.archetypes.confidence,
              } : null,
            }, null, 2)}</Code>
          </Card>
        ))}
      </Container>
    </Page>
  );
};

export default ScoringLab;

